import { GeneralModel } from "./general.model";

export class GetImagebyPathModel extends GeneralModel {
    fileName:string;
    fileExtension:string;
    fileBase64String:string;
}
